import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getPowerGenerationSourceList } from '../../../slices/powerGenerationSource/thunk';
import AddEditPowerGenerationSourceModal from './Add_Edit/AddEditPowerGenerationSource';
import DeletePowerGenerationSourceModal from './Delete/DeletePowerGenerationSource';
import AddEditPowerGenerationSourceMaintenanceModal from './Add_Edit/AddEditPowerGenerationSourceMaintenance';
import PowerGenerationSourceFilesModal from './Modals/PowerGenerationSourceFilesModal';

const PowerGenerationSourceList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorPowerGenerationSource = createSelector(
		state => state.PowerGenerationSource,
		data => ({
			powerGenerationSourceList: data.powerGenerationSourceList,
			isLoadingList: data.isLoadingList,
			isPowerGenerationSourceSuccess: data.isPowerGenerationSourceSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.rolesListSelect,
	// 	rolesListSelect => rolesListSelect
	// );

	// const rolesListSelect = useSelector(selectRolesList);

	const { powerGenerationSourceList, isLoadingList } = useSelector(
		selectorPowerGenerationSource
	);

	useEffect(() => {
		dispatch(getPowerGenerationSourceList());
	}, []);

	const [dataPowerGenerationSource, setDataPowerGenerationSource] = useState(
		{}
	);
	const [isEdit, setIsEdit] = useState(false);

	// Delete PowerGenerationSource
	const [modal, setModal] = useState(false);
	const [modalMaintenance, setModalMaintenance] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	const [modalFilesPowerGenerationSource, setModalFilesPowerGenerationSource] =
		useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalMaintenance() {
		setModalMaintenance(!modalMaintenance);
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	function handleToggleModalFilesPowerGenerationSource() {
		setModalFilesPowerGenerationSource(!modalFilesPowerGenerationSource);
	}

	// Delete Data
	const handleClickDelete = powerGenerationSource => {
		setDataPowerGenerationSource(powerGenerationSource);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = powerGenerationSource => {
		setDataPowerGenerationSource(powerGenerationSource);
		handleToggleModal();
	};

	// Update Data
	const handleClickMaintenance = powerGenerationSource => {
		setDataPowerGenerationSource(powerGenerationSource);
		handleToggleModalMaintenance();
	};

	const handleClickFilesPowerGenerationSource = powerGenerationSource => {
		setDataPowerGenerationSource(powerGenerationSource);
		handleToggleModalFilesPowerGenerationSource();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'powerGenerationSource',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const powerGenerationSourceData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(
														powerGenerationSourceData
													);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const powerGenerationSourceData =
														cellProps.row.original;
													handleClickDelete(
														powerGenerationSourceData
													);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const powerGenerationSourceData =
														cellProps.row.original;
													handleClickFilesPowerGenerationSource(
														powerGenerationSourceData
													);
												}}
												title='Ver Documentos'
											>
												<i className='ri-file-search-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},

			{
				header: 'Tipo de Establecimiento',
				accessorKey: 'establishment_type.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Establecimiento',
				accessorKey: 'establishment_name',
				accessorFn: row => row?.establishment?.name ?? row?.establishment_feeding_barges?.name ?? '-', // Extrae solo el nombre			
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					const establishmentName =
						row?.original?.establishment?.name ||
						row?.original?.establishment_feeding_barges?.name ||
						'-';
					const establishmentId =
						row?.original?.establishment_id ||
						row?.original?.establishment_feeding_barges?._id;

					return establishmentId && establishmentName !== '-' ? (
						<span
							onClick={() =>
								window.open(
									`/establishment/summary/${establishmentId}`,
									'_blank'
								)
							}
							style={{
								cursor: 'pointer',
								color: 'var(--vz-primary)',
								textDecoration: 'none',
								fontWeight: 'bold',
							}}
						>
							<i className="ri-links-line"></i> {establishmentName}
						</span>
					) : (
						<span>{establishmentName}</span>
					);
				},
			},
			{
				header: 'Artefacto Naval',
				accessorKey: 'feeding_barges.name',
				size: 'auto',
				dataType: 'multi-select',
				accessorFn: row => row?.establishment_type?.barges_needed ? row?.feeding_barges?.name ?? '-' : 'N/A', // Extrae solo el nombre
			},
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },
			{
				header: 'de de Propiedad',
				accessorKey: 'property_type',
				dataType: 'multi-select',
				size: 'auto',
				accessorFn: row => row?.property_type?.name ?? '-', // Extrae solo el nombre
				Cell: ({ row }) => {
					let status = row?.original?.property_type;
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return row?.original?.property_type ? (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgColor, color: txColor }}
							>
								{status
									? row.original.property_type.name
									: '-'}
							</span>
						</div>
					) : (
						'-'
					);
				},
			},
			{ 
				header: 'Número Serie', 
				accessorKey: 'serial_number', 
				size: 'auto' 
			},
			{
				header: 'Código RFP',
				accessorKey: 'rfp_code',
				size: 'auto',
			},
			{
				header: 'Marca',
				accessorKey: 'brand',
				size: 'auto',
			},
			{
				header: 'Modelo',
				accessorKey: 'model',
				size: 'auto',
			},
			{
				header: 'Estado',
				accessorKey: 'power_generation_status.name',
				size: 'auto',
				dataType: 'multi-select',
			},
			{
				header: 'Horómetro',
				accessorKey: 'hour_meter',
				dataType: 'separator',
				size: 'auto',
			},
			{
				header: 'Última Actualización',
				accessorKey: 'date_hour_meter',
				dataType: 'date',
				size: 'auto',
			},

			{
				header: 'Horas de Uso desde la Última Mantención',
				accessorKey: 'date_hour_mete_usage',
				dataType: 'datetime',
				size: 'auto',
				Cell: ({ row }) => {
					const hourMeterMaintenance =
						row?.original?.hour_meter_maintenance;
					const hourMeter = row?.original?.hour_meter;

					// Verifica que ambos valores existen antes de calcular
					if (hourMeterMaintenance != null && hourMeter != null) {
						return hourMeter - hourMeterMaintenance;
					} else {
						return '-';
					}
				},
			},
			{
				header: 'Diferencia Horas de Uso (%)',
				accessorKey: 'date_hour_meter_usage',
				dataType: 'percentage',
				size: 'auto',
				Cell: ({ row }) => {
					const hourMeterMaintenance =
						row?.original?.hour_meter_maintenance;
					const hourMeter = row?.original?.hour_meter;
					const hourMaintenance = row?.original?.hour_maintenance ?? 0;
					let badgeText = 'Sin mantención';

					// Verifica que los valores existen antes de calcular
					if (
						hourMeterMaintenance != null &&
						hourMeter != null &&
						hourMaintenance != null &&
						hourMaintenance !== 0
					) {
						const difference = hourMeter - hourMeterMaintenance;
						const percentageDifference =
							(difference / hourMaintenance) * 100;
						let badgeClass = '';

						// Define el color del badge según el valor de porcentaje
						if (percentageDifference <= 20) {
							badgeClass = 'bg-success';
							badgeText = 'Bajo';
						} else if (percentageDifference <= 50) {
							badgeClass = 'bg-info';
							badgeText = 'Moderado';
						} else if (percentageDifference <= 80) {
							badgeClass = 'bg-warning';
							badgeText = 'Alto';
						} else {
							badgeClass = 'bg-danger';
							badgeText = 'Muy Alto';
						}

						return (
							<span className={`badge ${badgeClass}`}>
								{`${percentageDifference.toFixed(0)}% - ${badgeText
									.toString()
									}`}
							</span>
						);
					} else {
						return (
							<span className={`badge bg-dark-subtle text-dark`}>
								{badgeText.toString()}
							</span>
						);
					}
				},
			},

			{
				header: 'Horómetro Mantención',
				accessorKey: 'hour_meter_maintenance',
				dataType: 'separator',
				size: 'auto',
			},
			{
				header: 'Fecha Mantención',
				accessorKey: 'date_hour_meter_maintenance',
				dataType: 'date',
				size: 'auto',
			},
			{
				header: 'Potencia (kW)',
				accessorKey: 'power_output',
				dataType: 'separator',
				size: 'auto',
			},
			{
				header: 'Tipo',
				accessorKey: 'power_generation_type.name',
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'de de combustible',
				accessorKey: 'fuel_type.name',
				dataType: 'multi-select',
				size: 'auto',
			},
			{ header: 'Descripción', accessorKey: 'description' },
		],
		[handleClickEdit, handleClickDelete, handleClickFilesPowerGenerationSource]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataPowerGenerationSource({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Fuente de Generación de Energía
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={powerGenerationSourceList || []}
								isLoadingData={isLoadingList}
								nameFile={'fuentes_de_generacion_de_energia'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										className: 'gap-1',
										onClick: () => {
											setIsEdit(false);
											setDataPowerGenerationSource({});
											handleToggleModal();
										},
										title: 'Crear Fuente de Generación de Energía',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditPowerGenerationSourceModal
				dataPowerGenerationSource={dataPowerGenerationSource}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>

			<AddEditPowerGenerationSourceMaintenanceModal
				dataPowerGenerationSource={dataPowerGenerationSource}
				isEdit={isEdit}
				isOpen={modalMaintenance}
				handleToggleModal={handleToggleModalMaintenance}
			/>

			<PowerGenerationSourceFilesModal
				dataPowerGenerationSource={dataPowerGenerationSource}
				isOpen={modalFilesPowerGenerationSource}
				handleToggleModal={handleToggleModalFilesPowerGenerationSource}
			/>

			<DeletePowerGenerationSourceModal
				dataPowerGenerationSource={dataPowerGenerationSource}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default PowerGenerationSourceList;
